import { buildTeamLogoOptions, getTeamLogoUrlByTeamId } from "@draftkings/sportsbook-common-utils";
/**
 * Gets the URL for a team logo based on configuration and feature flags.
 *
 * - When the Swoosh flag is enabled and the participant is a team, returns a Swoosh logo.
 * - When the flag is enabled but the participant is NOT a team, returns undefined (no fallback).
 * - Otherwise, returns the legacy logo URL from logos.json.
 */
export const getTeamLogoUrl = ({ participant, logos, swooshBaseUrl, staticS3Host, isSwooshTeamLogosEnabledForPrePacks, }) => {
    var _a;
    if (isSwooshTeamLogosEnabledForPrePacks) {
        const teamId = participant.rosettaTeamId;
        const logoUrl = getTeamLogoUrlByTeamId(swooshBaseUrl, teamId !== null && teamId !== void 0 ? teamId : "", buildTeamLogoOptions("sm", "dark", (_a = participant.venueRole) !== null && _a !== void 0 ? _a : ""));
        return logoUrl === null || logoUrl === void 0 ? void 0 : logoUrl.toString();
    }
    const participantLogo = logos.Teams[participant.name];
    return participantLogo && `${staticS3Host}${participantLogo}`;
};
//# sourceMappingURL=getTeamLogoUrl.js.map